import { ArrowRight } from "lucide-react";
import ozMoveLogoAsset from "@/assets/oz-move-logo.webp.asset.json";
import ozWasteLogoAsset from "@/assets/oz-waste-logo.webp.asset.json";

const ozMoveLogo = ozMoveLogoAsset.url;
const ozWasteLogo = ozWasteLogoAsset.url;

/**
 * Sister-brand link. Update OZ_MOVE_URL if the OZ MOVE CO. website
 * address changes, it is the single source of truth for this section.
 */
const OZ_MOVE_URL = "https://ozmoveco.com.au";

const MoveWasteCrossover = () => (
  <section className="bg-white py-16 md:py-24">
    <div className="container max-w-5xl">
      <h2 className="text-3xl md:text-4xl font-black text-[#1a1a1a] text-center mb-3">
        Moving House?
      </h2>
      <p className="text-center text-[#1a1a1a]/70 mb-12">
        Keep what you want. We'll handle the rest.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {/* Keeping it, OZ MOVE */}
        <div className="h-full rounded-2xl border-2 border-[#FDC00E]/30 bg-[#FFFBEB] p-8 flex flex-col">
          <img
            src={ozMoveLogo}
            alt="OZ MOVE CO. Logo"
            loading="lazy"
            decoding="async"
            width={480}
            height={320}
            className="w-20 h-auto object-contain mb-5"
          />
          <p className="text-xs font-black uppercase tracking-[0.18em] text-[#1a1a1a]/55 mb-2">
            Keeping it?
          </p>
          <h3 className="text-2xl font-black text-[#1a1a1a] mb-2">
            <a
              href={OZ_MOVE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-orange-deep transition-colors"
            >
              OZ MOVE CO.
            </a>
          </h3>
          <p className="text-[#1a1a1a]/70 mb-7">We'll move it to your new place.</p>
          <a
            href={OZ_MOVE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-auto inline-flex items-center justify-center gap-2 border-2 border-[#1a1a1a] text-[#1a1a1a] px-6 py-3.5 font-bold rounded-md hover:bg-orange/10 hover:border-orange hover:text-orange-deep transition-colors"
          >
            Visit OZ MOVE CO.
            <ArrowRight className="w-4 h-4 shrink-0" />
          </a>
        </div>

        {/* Getting rid of it, OZ WASTE */}
        <div className="h-full rounded-2xl border-2 border-orange/30 bg-[#FFF7ED] p-8 flex flex-col">
          <img
            src={ozWasteLogo}
            alt="OZ WASTE CO. Logo"
            loading="lazy"
            decoding="async"
            width={576}
            height={384}
            className="w-20 h-auto object-contain mb-5"
          />
          <p className="text-xs font-black uppercase tracking-[0.18em] text-orange-deep mb-2">
            Getting rid of it?
          </p>
          <h3 className="text-2xl font-black text-[#1a1a1a] mb-2">OZ WASTE CO.</h3>
          <p className="text-[#1a1a1a]/75 mb-7">We'll remove it for you.</p>
          <a
            href="/#quote"
            className="mt-auto inline-flex items-center justify-center gap-2 bg-[#1a1a1a] text-white px-6 py-3.5 font-bold rounded-md hover:bg-orange transition-colors"
          >
            Get a Waste Quote
            <ArrowRight className="w-4 h-4 shrink-0" />
          </a>
        </div>
      </div>

      <p className="text-center text-sm text-[#1a1a1a]/60 mt-8">
        Need both? Ask us about organising your move and rubbish removal together.
      </p>
    </div>
  </section>
);

export default MoveWasteCrossover;
